import { render, staticRenderFns } from "./GroupCreationForm.vue?vue&type=template&id=3157844c&scoped=true&lang=pug"
import script from "./GroupCreationForm.vue?vue&type=script&lang=js"
export * from "./GroupCreationForm.vue?vue&type=script&lang=js"
import style0 from "./GroupCreationForm.vue?vue&type=style&index=0&id=3157844c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3157844c",
  null
  
)

export default component.exports